var VERSION = 1789457014240

export  {
	VERSION
} 
